import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={22.856}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 40895 36368"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M5539 32218c-179-358-182 453-146-431l6067 5-36-1236-6404-2 3-21699 30881 52 4 21643-6955 9 73 1309 6421 20c-705 3060-2956 2605-6183 2605H11776c-3477 0-4984 592-6237-2275zM37729 6995c1195-140 1303-74 1315 1105 12 2612 491 5780-1315 6207l3-5094-3-2218zM3190 14341c-1600-611-1312-1907-1311-3697 0-847-22-1715-13-2558 13-1144 231-1142 1324-1134v7389zm1956-7422c-229-2176 2137-4842 5194-5009l20507 17c2502 220 4955 2418 4980 4991l-30681 1zM3863 32991c792 1685 1705 3037 3878 3298 1285 155 19144 32 21365 32 2341 0 4553 330 6186-886 1275-949 2410-3319 2444-4751 110-4727-23-9586-4-14332 1286-628 1931-590 2667-1886 654-1149 471-2495 471-3981 0-3748 550-5344-3546-5370-457-1946-2195-3571-3769-4328-2107-1015-4906-715-7470-715-5371 0-11042-175-16375 22-2307 439-4036 1357-5272 3214-347 524-670 1520-1088 1811-4023-2-3299 2060-3299 5684 0 1516-143 2723 582 3830 786 1199 2291 1437 2558 1893l-1 12879c-3 2275 17 1782 673 3586z"
        className="fil0"
      />
      <path
        d="M19762 16964c1642-388 2932 518 3567 1365 903 1206 690 2882 690 4556 0 8887 700 7915-2545 7912-5747-6-4530 1070-4530-6003 0-3595-708-6998 2818-7830zm-4628 13712c163 841 993 1676 1775 1867 723 177 2606 80 3452 80 6369 0 5486-159 5486-8624 0-2308 263-4467-744-6329-732-1356-2485-2629-4581-2652-2339-28-3795 1253-4587 2492-1161 1812-859 3797-859 6171 0 1603-200 5672 58 6995z"
        className="fil0"
      />
      <path
        d="m18136 27538 4727-12 4-1263-4730-41zM21674 21572l117-1233-2739 2 24 1233zM5539 32218c316-354-429-188 662-291l4787 29c819-85 178 18 472-164l-6067-5c-36 884-33 73 146 431z"
        className="fil0"
      />
      <path
        d="M21674 21572c365-141 433-244 201-1315-543-118-2307-212-2823 84l2739-2-117 1233z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
